<template>
  <div class="enroll-distribute-status-main"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="details">
      <template v-if="details.length">
        <AppScrollbar style="height: 100%">
          <div class="main-cont">
            <div class="steps">
              <div class="step">
                <span class="label">步骤1：</span>
                <span>选择分配年级后“下载模板”，将新生数据导出，并在模版中填入学生的班级和学号；</span>
              </div>
              <div class="step">
                <span class="label">步骤2：</span>
                <span>将填入好的数据重新导入至系统，新生分班赋学号完成；</span>
              </div>
            </div>
            <div class="grades">
              <span class="label">选择分配年级：</span>
              <el-checkbox-group v-model="grades">
                <el-checkbox v-for="detail in details"
                             :key="detail.id"
                             :label="detail.id">
                  {{detail.grade}}（{{detail.count || 0}}人）
                </el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="submit-cont">
              <DataImportModule :import-url="submitUrl"
                                :pre-handle-params="submitParams"
                                :pre-handle-verify="submitVerify"
                                inline
                                @dataImportSuccess="loadDetails"></DataImportModule>
            </div>
          </div>
        </AppScrollbar>
      </template>
      <template v-else>
        <Hint type="empty">
          <div>没有可导入的新生数据</div>
        </Hint>
      </template>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>请求数据加载失败</div>
        <el-button type="text"
                   @click="loadDetails">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../elements/AppScrollbar'
import DataImportModule from '../../../../../../elements/DataImportModule'
import Hint from '../../../../../../elements/Hint'
export default {
  name: 'EnrollDistributeStatusMain',
  components: {
    AppScrollbar,
    DataImportModule,
    Hint
  },
  data () {
    return {
      submitUrl: '/workspace/manager/enroll/distribute/student/submit',
      loading: false,
      details: null,
      grades: []
    }
  },
  methods: {
    loadDetails () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enroll/distribute/student/details',
        method: 'post'
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.details = response.data['details'] || []
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    submitParams () {
      return {
        grades: this.grades
      }
    },
    submitVerify () {
      if (!this.grades || !this.grades.length) {
        this.$message.warning('请先选择分配年级')
        return
      }
      return true
    }
  },
  mounted () {
    this.loadDetails()
  },
  activated () {
    this.loadDetails()
  },
  watch: {
    details: function (val) {
      if (val) {
        this.grades = val.map(detail => detail.id)
      } else {
        this.grades = []
      }
    }
  }
}
</script>

<style lang="scss">
  .enroll-distribute-status-main {
    height: 100%;
    .main-cont {
      margin: 30px auto;
      width: 540px;
      max-width: 100%;
      & > .steps {
        & > .step {
          font-size: 12px;
          & > .label {
            color: #606266;
            font-weight: bold;
          }
          & + .step {
            margin-top: 8px;
          }
        }
      }
      & > .grades {
        margin-top: 20px;
        & > .label {
          color: #606266;
          font-size: 12px;
        }
        .el-checkbox-group {
          margin-top: 5px;
          .el-checkbox {
            .el-checkbox__label {
              font-size: 12px;
            }
          }
        }
      }
      & > .submit-cont {
        margin-top: 25px;
      }
    }
  }
</style>
